import { faTimes } from '@fortawesome/pro-regular-svg-icons/faTimes';
import React from 'react';
import { Box } from '@osmosis/tailwind-ui/components/Box';
import { Flex } from '@osmosis/tailwind-ui/components/Box';
import { Icon } from '@osmosis/tailwind-ui/components/Icon';
import {
  IconButton,
  IconButtonProps,
} from '@osmosis/tailwind-ui/components/IconButton';
import { H1, H2 } from '@osmosis/tailwind-ui/components/Text';
import { useIntl } from 'react-intl';
import { closeButtonTestId } from './Modal';

type Props = {
  text?: string;
  secondaryText?: string;
  textStyles?: string;
  secondaryTextStyles?: string;
  containerStyles?: string;
  onClose?: () => void;
  headerNode?: React.ReactNode;
  iconProps?: IconButtonProps;
  ariaLabel?: string;
  hideCloseButton?: boolean;
};

/**
 * ModalHeader.
 */
const ModalHeader = (props: Props) => {
  const {
    text,
    onClose,
    secondaryText = '',
    secondaryTextStyles = '',
    headerNode,
    containerStyles = '',
    textStyles = '',
    iconProps = {},
    ariaLabel = 'Close',
    hideCloseButton,
  } = props;

  const intl = useIntl();

  return (
    <Flex
      className={`flex justify-center items-center p-3 sticky top-0 border-b border-gray-200 z-10 ${containerStyles}`}
    >
      {headerNode ? (
        headerNode
      ) : (
        <Flex className="flex opacity-75 gap-[6px]" data-testid="modal-header">
          <H1 className={`text-[20px] ${textStyles}`}>{text}</H1>
          {secondaryText && (
            <H2 className={secondaryTextStyles}>{secondaryText}</H2>
          )}
        </Flex>
      )}
      <Box className="absolute right-0 mr-3">
        {!hideCloseButton && (
          <IconButton
            variant="transparent"
            onClick={onClose}
            icon={<Icon icon={faTimes} />}
            {...iconProps}
            data-testid={closeButtonTestId}
            aria-label={ariaLabel}
          >
            <span className="visually-hidden">
              {intl.formatMessage({
                id: 'modal-header.close',
                defaultMessage: 'Close popup',
              })}
            </span>
          </IconButton>
        )}
      </Box>
    </Flex>
  );
};

export default ModalHeader;
